import { render, staticRenderFns } from "./CorrectSequenceAnswer.vue?vue&type=template&id=1612bf2b&scoped=true&"
import script from "./CorrectSequenceAnswer.vue?vue&type=script&lang=ts&"
export * from "./CorrectSequenceAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectSequenceAnswer.vue?vue&type=style&index=0&id=1612bf2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612bf2b",
  null
  
)

export default component.exports